import { createFileRoute } from '@tanstack/react-router'

import { LoadingLines } from '@/components/skeletons'
import { Page } from '@/components/page'
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert'
import { PartForm, draftFromPart } from '@/features/parts/PartForm'
import { usePart } from '@/features/parts/api'

export const Route = createFileRoute('/parts/$partId/edit')({ component: EditPartPage })

function EditPartPage() {
  const { partId } = Route.useParams()
  const part = usePart(partId)

  return (
    <Page title={part.data ? `Edit ${part.data.name}` : 'Edit part'}>
      {part.isPending ? (
        <LoadingLines label="Loading the part" lines={6} />
      ) : part.isError || !part.data ? (
        <Alert variant="destructive">
          <AlertTitle>Could not load this part</AlertTitle>
          <AlertDescription>
            {part.error instanceof Error ? part.error.message : 'It may have been deleted.'}
          </AlertDescription>
        </Alert>
      ) : (
        <PartForm partId={partId} initial={draftFromPart(part.data)} />
      )}
    </Page>
  )
}
